import { expensesApi } from '../api/expensesApi'
import type { ExpenseCreateData } from '../schema/expensesSchema'

export const createExpense = async ({
  expense,
}: {
  expense: ExpenseCreateData
}) => {
  try {
    const { data } = await expensesApi.createExpense(expense)
    return data
  } catch (error) {
    console.error(`Error creating expense: `, error)
    throw error
  }
}
